import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Configuration } from 'src/app/app.constants';
import {
  AssignUser,
  LocationAssignmentDetails,
  LocationAssignmentFilter,
  LocationAssignmentSaveRequest,
  LocationGroupWithLocations,
  UnassignedLocation,
  VenueBuilding,
  VenueZone,
} from '../models/location-assignment.model';

@Injectable()
export class AssignAlertsHttpService {
  constructor(
    private readonly http: HttpClient,
    private readonly configuration: Configuration,
  ) {}

  /**
   * Gets the location assignment details for Alerts/Inspections
   *
   * @param detailsEndpoint get details endpoint for the screen.
   * @param filter Selected user id.
   */
  GetAssignmentDetails = (
    detailsEndpoint: string,
    filter: LocationAssignmentFilter,
  ): Observable<LocationAssignmentDetails> => {
    const _url: string = this.configuration.Server + detailsEndpoint;
    return this.http.post<LocationAssignmentDetails>(_url, filter);
  };

  /**
   * Save the user's direct location assignments and location group assignments together.
   *
   * @param saveEndpoint save endpoint for the save.
   * @param body Selected user, direct location ids and group identities.
   */
  SaveLocationAssignments = (saveEndpoint: string, body: LocationAssignmentSaveRequest): Observable<void> => {
    const _url: string = this.configuration.Server + saveEndpoint;
    return this.http.post<void>(_url, body);
  };

  /**
   * Gets the users eligible for assignment.
   *
   * @param userListEndpoint endpoint for the user list.
   */
  GetUsers = (userListEndpoint: string): Observable<AssignUser[]> => {
    const filter = JSON.stringify({ SearchQuery: '', genericSearch: 0, '': {} });
    const _url: string = this.configuration.Server + userListEndpoint;
    return this.http.post<AssignUser[]>(_url, filter);
  };

  /**
   * Gets all active buildings for the current context venue.
   */
  GetBuildings = (): Observable<VenueBuilding[]> => {
    const _url: string = this.configuration.Server + 'v2/facility/buildings-all';
    return this.http.get<VenueBuilding[]>(_url);
  };

  /**
   * Gets all active zones for the current context venue.
   */
  GetZones = (): Observable<VenueZone[]> => {
    const _url: string = this.configuration.Server + 'v2/facility/zones-all';
    return this.http.get<VenueZone[]>(_url);
  };

  /**
   * Gets all the venue's location groups, each with its locations.
   */
  GetLocationGroupsWithLocations = (): Observable<LocationGroupWithLocations[]> => {
    const _url: string = this.configuration.Server + 'v2/facility/location-groups-all';
    return this.http.get<LocationGroupWithLocations[]>(_url);
  };

  /**
   * Gets locations not yet assigned to any user.
   *
   * @param search Optional search term.
   * @param page Page number.
   * @param size Page size.
   */
  GetUnassignedLocations = (search: string, page: number, size: number): Observable<UnassignedLocation[]> => {
    const filter = JSON.stringify({ SearchQuery: search ? search.trim() : '', genericSearch: 0, '': {} });
    const _url: string = this.configuration.Server + 'venue/location/unassinged/users/' + page + '/' + size;
    return this.http.post<UnassignedLocation[]>(_url, filter);
  };
}
